import { API } from '../../config';
var shippo = require('shippo')('shippo_test_78a3a7e8883b86a4f9d562017f313dfd9b24fb71');

const warehouse = {
    'street1': '6307 Big Oak Canyon Dr',
    'city': 'Richmond',
    'state': 'TX',
    'zip': 77469,
    'country': 'US'
};
const priorityId = 'cb6f6532e6e04c7c85d2757dd780ea39';
const serviceLevelToken = 'usps_prioirty';

export const senderGenerateShipping = (userId, orderId, token, senderParcelInfo) => {
    return fetch(`${API}/sender-generate-shipping/${userId}/${orderId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({senderParcelInfo: senderParcelInfo})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const recieverGenerateShipping = (userId, orderId, token, recieverProduct) => {
    return fetch(`${API}/reciever-generate-shipping/${userId}/${orderId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({'recieverProduct': recieverProduct})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const paymentStatus = (userId, orderId, token) => {
    return fetch(`${API}/payment-status/${userId}/${orderId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(err => console.log(err));
};
